import { serverError } from './../../../../core/models/messages';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from './../../../../core/services/local-storage.service';
import { StripeService } from './../../../../core/services/stripeService/stripe-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.css'],
})
export class PaymentMethodComponent {
  listCards: any;
  totalItems: any;
  company_id: any;
  searchElement: any;
  currentUser: any;
  stripe_id: any;
  private unsubscribeAll: Subject<void> = new Subject();

  constructor(
    private stripeService: StripeService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private toastr: ToastrService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnInit() {
    this.getStripeId();
    this.company_id = this.localStorageService.getData('clientConnected');
    this.getListCard();
  }
  getStripeId() {
    this.currentUser = this.localStorageService.getData('UserInfo');
    this.stripe_id = JSON.parse(this.currentUser).stripe_id;
    console.log('stripe_id', this.stripe_id);
  }
  /* get list offer */
  getListCard() {
    this.spinner.show();
    this.stripeService
      .getListOfCard(this.stripe_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listCards = res.data.data;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
          this.toastr.error(serverError);
        },
      });
  }

  CheckoutAddCard() {
    this.stripeService.redirectToCheckoutAddCard(this.company_id).subscribe(
      (response) => {
        console.log(response.data.url);
        window.location.href = response.data.url;
      },
      (error) => {
        console.error(
          'There has been a problem with your fetch operation:',
          error
        );
      }
    );
  }

  navigateToDetails(offerId: any) {
    this.router.navigate(['/offer-details', { abonnementId: offerId }]);
  }
  navigateToInvoiceHistory(offerId: any) {
    this.router.navigate(['/invoices', { abonnementId: offerId }]);
  }
  applyFilter() {
    let data = {
      search: this.searchElement?.trim().toLowerCase(),
    };
    this.spinner.show();
    this.stripeService
      .searchCards(data, this.stripe_id)
      .pipe(takeUntil(this.unsubscribeAll))
      .subscribe({
        next: (res) => {
          this.listCards = res.data.data;
          this.spinner.hide();
        },
        error: () => {
          this.spinner.hide();
        },
      });
  }

  removeCard(id: any) {
    Swal.fire({
      title: 'Êtes-vous sûr(e) ?',
      text: 'Vous ne pourrez pas revenir en arrière !',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085D6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Oui, supprimer !',
    }).then((result) => {
      if (result.isConfirmed) {
        this.stripeService.deleteCard(id).subscribe((res: any) => {
          this.getListCard();
        });
      }
    });
  }

  /* unsubscribe from api */
  ngOnDestroy() {
    this.unsubscribeAll.next();
    this.unsubscribeAll.complete();
  }
}
